// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDrXKvbchusFk7RtvlzvOKpdMeMqlT_jLE",
  authDomain: "newhatch-1.firebaseapp.com",
  projectId: "newhatch-1",
  storageBucket: "newhatch-1.appspot.com",
  messagingSenderId: "74265225938",
  appId: "1:74265225938:web:e61168015f42ad02349b0b",
  measurementId: "G-ENLD9QC0YC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
// export const firestore = getFirestore(app);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();